var _path, _rect, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _path12, _path13, _circle2, _path14, _g, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderInfographics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 158,
    viewBox: "0 0 358 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H352C355.314 0 358 2.68629 358 6V158H0V6Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 113.019,
    width: 159,
    height: 20.9346,
    rx: 2,
    fill: "#091526",
    fillOpacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 123.019H84",
    stroke: "#091526",
    strokeOpacity: 0.35,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94 123.019H106",
    stroke: "#091526",
    strokeOpacity: 0.35,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 123.019,
    r: 5,
    fill: "#A9D177"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156 48.9813C156 46.7722 157.791 44.9813 160 44.9813H164C166.209 44.9813 168 46.7722 168 48.9813V73.243H156V48.9813Z",
    fill: "#091526",
    fillOpacity: 0.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114 44.7944C114 42.5852 115.791 40.7944 118 40.7944H122C124.209 40.7944 126 42.5852 126 44.7944V73.243H114V44.7944Z",
    fill: "#A9D177"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53.1682C72 50.9591 73.7909 49.1682 76 49.1682H80C82.2091 49.1682 84 50.9591 84 53.1682V73.243H72V53.1682Z",
    fill: "#091526",
    fillOpacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53.1682C51 50.9591 52.7909 49.1682 55 49.1682H59C61.2091 49.1682 63 50.9591 63 53.1682V73.243H51V53.1682Z",
    fill: "#091526",
    fillOpacity: 0.07
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67.8224C30 65.6133 31.7909 63.8224 34 63.8224H38C40.2091 63.8224 42 65.6133 42 67.8224V73.243H30V67.8224Z",
    fill: "#F77DA5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135 37.4673C135 35.2581 136.791 33.4673 139 33.4673H143C145.209 33.4673 147 35.2581 147 37.4673V73.243H135V37.4673Z",
    fill: "#A9D177"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37.4673C93 35.2581 94.7909 33.4673 97 33.4673H101C103.209 33.4673 105 35.2581 105 37.4673V73.243H93V37.4673Z",
    fill: "#A9D177"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177 30.1402C177 27.9311 178.791 26.1402 181 26.1402H185C187.209 26.1402 189 27.9311 189 30.1402V73.243H177V30.1402Z",
    fill: "#A9D177"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 83.7103,
    width: 159,
    height: 20.9346,
    rx: 2,
    fill: "#091526",
    fillOpacity: 0.07
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 93.7103H72.5",
    stroke: "#091526",
    strokeOpacity: 0.35,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82 93.7103H94",
    stroke: "#091526",
    strokeOpacity: 0.35,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 93.7103,
    r: 5,
    fill: "#F77DA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9808_28323",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 23,
    width: 107,
    height: 112
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318.435 79C318.435 105.062 298.358 125.435 274.5 125.435C250.642 125.435 230.565 105.062 230.565 79C230.565 52.9384 250.642 32.5652 274.5 32.5652C298.358 32.5652 318.435 52.9384 318.435 79Z",
    stroke: "#C4C4C4",
    strokeWidth: 19.1304
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9808_28323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.5 23C244.953 23 221 48.0721 221 79H274.5V23Z",
    fill: "#091526",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5 135C244.953 135 221 109.928 221 79H274.5V135Z",
    fill: "#091526",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5 23C304.047 23 328 48.0721 328 79C328 109.928 304.047 135 274.5 135V23Z",
    fill: "#DAFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5 135V137H274.5C305.237 137 330 110.945 330 79V77H328H274.5H272.5V79V135Z",
    fill: "#A9D177",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5 79V135C290.212 135 304.329 128.196 314.043 116.739L274.5 79Z",
    fill: "#A9D177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5 23V21H274.5C305.237 21 330 47.0545 330 79V81H328H274.5H272.5V79V23Z",
    fill: "#83DEFA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.873 80.4543L272.5 83.6387V79V23V21H274.5C290.845 21 305.505 28.5039 315.569 40.3732L316.795 41.8193L315.416 43.1209L275.873 80.4543Z",
    fill: "#957AFE",
    stroke: "white",
    strokeWidth: 4
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M258.132 76.4548C258.132 77.0468 257.952 77.5188 257.592 77.8708C257.24 78.2228 256.804 78.4628 256.284 78.5908V78.6268C256.972 78.7068 257.492 78.9148 257.844 79.2508C258.204 79.5868 258.384 80.0388 258.384 80.6068C258.384 81.1028 258.26 81.5508 258.012 81.9508C257.772 82.3428 257.396 82.6548 256.884 82.8868C256.38 83.1108 255.728 83.2228 254.928 83.2228C254 83.2228 253.176 83.0668 252.456 82.7548V81.2188C252.824 81.4028 253.208 81.5428 253.608 81.6388C254.016 81.7348 254.392 81.7828 254.736 81.7828C255.384 81.7828 255.836 81.6708 256.092 81.4468C256.356 81.2228 256.488 80.9068 256.488 80.4988C256.488 80.2588 256.428 80.0588 256.308 79.8988C256.188 79.7308 255.976 79.6068 255.672 79.5268C255.376 79.4388 254.96 79.3948 254.424 79.3948H253.776V78.0028H254.436C254.964 78.0028 255.364 77.9548 255.636 77.8588C255.916 77.7548 256.104 77.6188 256.2 77.4508C256.304 77.2748 256.356 77.0748 256.356 76.8508C256.356 76.5468 256.26 76.3108 256.068 76.1428C255.884 75.9668 255.572 75.8788 255.132 75.8788C254.724 75.8788 254.368 75.9508 254.064 76.0948C253.768 76.2308 253.516 76.3668 253.308 76.5028L252.468 75.2548C252.804 75.0148 253.196 74.8148 253.644 74.6548C254.1 74.4948 254.64 74.4148 255.264 74.4148C256.144 74.4148 256.84 74.5948 257.352 74.9548C257.872 75.3068 258.132 75.8068 258.132 76.4548ZM267.216 76.5508H269.184L266.592 79.6948L269.412 83.1028H267.384L264.708 79.7788V83.1028H262.92V76.5508H264.708V79.7308L267.216 76.5508ZM276.218 83.1028H274.43V77.8948H272.786C272.682 79.1748 272.542 80.2068 272.366 80.9908C272.198 81.7668 271.962 82.3348 271.658 82.6948C271.354 83.0468 270.946 83.2228 270.434 83.2228C270.018 83.2228 269.678 83.1588 269.414 83.0308V81.6028C269.598 81.6828 269.79 81.7228 269.99 81.7228C270.134 81.7228 270.266 81.6508 270.386 81.5068C270.506 81.3628 270.618 81.1028 270.722 80.7268C270.834 80.3508 270.934 79.8268 271.022 79.1548C271.11 78.4748 271.19 77.6068 271.262 76.5508H276.218V83.1028ZM280.772 76.4188C281.652 76.4188 282.324 76.6108 282.788 76.9948C283.26 77.3708 283.496 77.9508 283.496 78.7348V83.1028H282.248L281.9 82.2148H281.852C281.572 82.5668 281.276 82.8228 280.964 82.9828C280.652 83.1428 280.224 83.2228 279.68 83.2228C279.096 83.2228 278.612 83.0548 278.228 82.7188C277.844 82.3748 277.652 81.8508 277.652 81.1468C277.652 80.4508 277.896 79.9388 278.384 79.6108C278.872 79.2748 279.604 79.0908 280.58 79.0588L281.72 79.0228V78.7348C281.72 78.3908 281.628 78.1388 281.444 77.9788C281.268 77.8188 281.02 77.7388 280.7 77.7388C280.38 77.7388 280.068 77.7868 279.764 77.8828C279.46 77.9708 279.156 78.0828 278.852 78.2188L278.264 77.0068C278.616 76.8228 279.004 76.6788 279.428 76.5748C279.86 76.4708 280.308 76.4188 280.772 76.4188ZM281.024 80.0908C280.448 80.1068 280.048 80.2108 279.824 80.4028C279.6 80.5948 279.488 80.8468 279.488 81.1588C279.488 81.4308 279.568 81.6268 279.728 81.7468C279.888 81.8588 280.096 81.9148 280.352 81.9148C280.736 81.9148 281.06 81.8028 281.324 81.5788C281.588 81.3468 281.72 81.0228 281.72 80.6068V80.0668L281.024 80.0908ZM287.991 83.2228C287.015 83.2228 286.259 82.9548 285.723 82.4188C285.195 81.8748 284.931 81.0228 284.931 79.8628C284.931 79.0628 285.067 78.4108 285.339 77.9068C285.611 77.4028 285.987 77.0308 286.467 76.7908C286.955 76.5508 287.515 76.4308 288.147 76.4308C288.595 76.4308 288.983 76.4748 289.311 76.5628C289.647 76.6508 289.939 76.7548 290.187 76.8748L289.659 78.2548C289.379 78.1428 289.115 78.0508 288.867 77.9788C288.627 77.9068 288.387 77.8708 288.147 77.8708C287.219 77.8708 286.755 78.5308 286.755 79.8508C286.755 80.5068 286.875 80.9908 287.115 81.3028C287.363 81.6148 287.707 81.7708 288.147 81.7708C288.523 81.7708 288.855 81.7228 289.143 81.6268C289.431 81.5228 289.711 81.3828 289.983 81.2068V82.7308C289.711 82.9068 289.423 83.0308 289.119 83.1028C288.823 83.1828 288.447 83.2228 287.991 83.2228ZM294.155 83.2228C293.179 83.2228 292.423 82.9548 291.887 82.4188C291.359 81.8748 291.095 81.0228 291.095 79.8628C291.095 79.0628 291.231 78.4108 291.503 77.9068C291.775 77.4028 292.151 77.0308 292.631 76.7908C293.119 76.5508 293.679 76.4308 294.311 76.4308C294.759 76.4308 295.147 76.4748 295.475 76.5628C295.811 76.6508 296.103 76.7548 296.351 76.8748L295.823 78.2548C295.543 78.1428 295.279 78.0508 295.031 77.9788C294.791 77.9068 294.551 77.8708 294.311 77.8708C293.383 77.8708 292.919 78.5308 292.919 79.8508C292.919 80.5068 293.039 80.9908 293.279 81.3028C293.527 81.6148 293.871 81.7708 294.311 81.7708C294.687 81.7708 295.019 81.7228 295.307 81.6268C295.595 81.5228 295.875 81.3828 296.147 81.2068V82.7308C295.875 82.9068 295.587 83.0308 295.283 83.1028C294.987 83.1828 294.611 83.2228 294.155 83.2228Z",
    fill: "#A3BBD0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.0467H67",
    stroke: "#091526",
    strokeOpacity: 0.07,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.514H50",
    stroke: "#091526",
    strokeOpacity: 0.07,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderInfographics);
export default __webpack_public_path__ + "static/media/header_infographics.4f663e2d3510a7d8d6af619536cedfc9.svg";
export { ForwardRef as ReactComponent };